import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  ChatStates,
  selectChatState,
  triggerVHState,
  untriggeredVHStatesSelector,
} from '../../slices/chat/ChatSlice';
import { usePrevious } from '../../utility/StateHooks';
import { useInterval } from '../../utility/TimerHooks';

const StatesTimer = () => {
  const chatState = useSelector(selectChatState);
  const allUntriggeredVHStates = useSelector(untriggeredVHStatesSelector);
  const timeStart = useRef(new Date().getTime());
  const dispatch = useDispatch();

  useEffect(() => {
    if (chatState === ChatStates.TALK) {
      timeStart.current = new Date().getTime();
    }
  }, [chatState]);

  useInterval(() => {
    if (chatState !== ChatStates.TALK) {
      return;
    }
    const timePassed = new Date().getTime() - timeStart.current;
    allUntriggeredVHStates.forEach((state) => {
      if (state.triggerTime && timePassed > state.triggerTime) {
        dispatch(triggerVHState(state));
      }
    });
  }, 500);
  return <></>;
};
export default StatesTimer;
